module.exports = __webpack_public_path__ + "static/L5Y0-2fdd0e62a4633aa736215a9bfa0e7540.jpg";